import { Component, Input, OnInit } from "@angular/core";
import { Events, MenuController } from "ionic-angular";
import {
  AppStatus,
  ConnectionStatusEnum,
} from "../../../providers/app-status/app-status";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";
import { NavBarServiceProvider } from "../../../providers/nav-bar-service/nav-bar-service";
import { StateManagementService } from "./../../../providers/state-management/state-management.service";

@Component({
  selector: "visit-page-navigation",
  templateUrl: "visit-page-navigation.html",
})
export class VisitsPageNavigation implements OnInit {
  isMobilePlatform: boolean;
  appSyncStatus: ConnectionStatusEnum;
  connectionStatusEnum = ConnectionStatusEnum;

  @Input()
  currentPatientChartId: number = null;
  @Input()
  activeTab: string = null;
  @Input()
  showCtiFeatures: boolean = false;

  constructor(
    public mobileUtilsProvider: MobileUtilsProvider,
    public menuCtrl: MenuController,
    public appStatus: AppStatus,
    public stateData: StateManagementService,
    private navBarServiceProvider: NavBarServiceProvider,
    private events: Events
  ) {
    // Filtered out non working tabs from Mobile App
    if (mobileUtilsProvider.isMobilePlatform()) {
      this.navTabs = this.mobileUtilsProvider.getMobileAppNavigation(
        "Careplan",
        this.appStatus.getAppStatus() === this.connectionStatusEnum.Online
      );
    }
  }

  ngOnInit(): void {
    if (this.navBarServiceProvider.getPatientChartStatus() == undefined) {
      this.events.publish("patientChartIdChange");
    }
    this.navTabs = this.navTabs.map((tab) => {
      tab.active = this.activeTab === tab.icon;
      return tab;
    });
  }

  navTabs: any[] = [
    {
      label: "Profile",
      icon: "profile",
    },
    {
      label: "Activity",
      icon: "activity",
    },
    {
      label: "Careplan",
      icon: "carePlan",
      url: "/carePlan/visits",
    },
    {
      label: "Careteam",
      icon: "careTeam",
      url: "/careTeams",
    },
    {
      label: "Meds/Mngt",
      icon: "medsDme",
    },
    {
      label: "Reports",
      icon: "reports",
      url: "/report-list",
    },
    {
      label: "Notes",
      icon: "notes",
    },
    {
      label: "Documents",
      icon: "documents",
      url: "/docManagement/docManagement",
    },
    {
      label: "Certifications",
      name: "certs",
      icon: "consents",
      url: "/certs-consents",
    },
    {
      label: "Bereavements",
      name: "bereavement",
      icon: "consents",
      url: "/pdb",
    },
  ];

  goTo(url: string) {
    if (url === "/certs-consents") {
      if (!this.showCtiFeatures) {
        return;
      }
    }
    if (url === "/report-list") {
      if (!this.stateData.HIS.value) {
        return;
      }
    }
    if (this.mobileUtilsProvider.checkIfMobile()) {
      this.menuCtrl.close();
    }
    const patientChartId = window.location.href.split("/")[5];
    let baseUrl = "";
    if (url === "/report-list") {
      baseUrl =
        window.location.href.split("#")[0] +
        "#/reports/" +
        patientChartId +
        url;
    } else {
      baseUrl =
        window.location.href.split("#")[0] +
        "#/patient/" +
        patientChartId +
        url;
    }
    if (url) {
      window.location.href = baseUrl;
    }
  }

  setActivePage(pageName: string) {
    const page = this.navTabs.filter(
      (page) => page.name && page.name.toLowerCase() === pageName
    );
    if (page) {
      this.navTabs.forEach((page) => {
        page.active = page.name && page.name.toLowerCase() === pageName;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/visit-page-navigation/visit-page-navigation.ts